'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.selection = [];
  }

  $onInit() {
    this.getBetaGroup();
    this.getBetaGroups();
  }

  getBetaGroup() {
    this.$http.get(`/api/betaGroups/${this.$stateParams.id}`).then(res => {
      this.betagroup = res.data;
    });
  }

  save() {
    this.$http.put(`/api/betaGroups/${this.$stateParams.id}`, this.betagroup).then(res => {
      this.$state.go('^');
    });
  }

  remove(id) {
    this.$http.post(`/api/betaGroups/${this.$stateParams.id}/removeUser`, {users: [id]}).then(res => {
      this.getBetaGroup();
    });
  }

  toggleSelection(id) {
    let idx = this.selection.indexOf(id);
    if (idx > -1) {
      this.selection.splice(idx, 1);
    } else {
      this.selection.push(id);
    }
  }

  batchRemove() {
    if (confirm("确定？")) {
      this.$http.post(`/api/betaGroups/${this.$stateParams.id}/removeUser`, {
        users: this.selection
      }).then(res => {
        this.getBetaGroup();
      });
    }
  }

  batchMove(id) {
    if (confirm("确定？")) {
      let params = {
        users: this.selection,
        from: this.$stateParams.id,
        to: id
      };
      this.$http.post(`/api/betaGroups/moveUsers`, params).then(res => {
        this.getBetaGroup();
      });
    }
  }

  getBetaGroups() {
    this.$http.get('/api/betaGroups').then(res => {
      this.betaGroups = res.data;
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/betagroups/show/show.controller.js